var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9819 5.10645V14.4002C31.9819 15.6603 31.9819 16.2903 32.2272 16.7716C32.4429 17.195 32.7871 17.5392 33.2105 17.7549C33.6918 18.0002 34.3218 18.0002 35.5819 18.0002H44.8756M36.4819 29.25H18.4819M36.4819 38.25H18.4819M22.9819 20.25H18.4819M31.9819 4.5H20.2819C16.5016 4.5 14.6114 4.5 13.1675 5.23571C11.8974 5.88285 10.8648 6.91547 10.2176 8.18556C9.48193 9.62947 9.48193 11.5196 9.48193 15.3V38.7C9.48193 42.4804 9.48193 44.3705 10.2176 45.8144C10.8648 47.0845 11.8974 48.1171 13.1675 48.7643C14.6114 49.5 16.5016 49.5 20.2819 49.5H34.6819C38.4623 49.5 40.3525 49.5 41.7964 48.7643C43.0665 48.1171 44.0991 47.0845 44.7462 45.8144C45.4819 44.3705 45.4819 42.4804 45.4819 38.7V18L31.9819 4.5Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralIcon);
export default __webpack_public_path__ + "static/media/generalIcon.3e7e41ee8e44044c58296da888ea6738.svg";
export { ForwardRef as ReactComponent };